export default __webpack_public_path__ + "static/media/2255.52d51abb.png";